const Style = {

  base: 'inline-block mx-1 py-1 px-2.5 uppercase text-xs font-semibold rounded-badge',
  red: 'bg-sg-red-bg text-sg-red',
  blue: 'bg-sg-blue-tint text-sg-blue-ink',
  green: 'bg-sg-green-bg text-sg-green',
  orange: 'bg-sg-orange-bg text-sg-orange',

}

export default Style;